if(document.querySelector('.announcement-bar')){
  const announcementBars = document.querySelectorAll('.announcement-bar');
  announcementBars.forEach(announcementBar => {
    const btnClose = announcementBar.querySelector('.js-close-announcement');
    if (announcementBar.querySelector('.js-close-announcement')) {
      btnClose.addEventListener('click', () => {
        announcementBar.classList.add('close');
      });
    }
  });
}